import { supabase } from '../supabaseClient'

export async function listarUsuariosMenuWhatsApp() {
  const { data, error } = await supabase
    .from('usuarios_sistema')
    .select('id, nome, email, chat_zap, status')
    .eq('status', 'ativo')
    .order('nome')
  if (error) return { success: false, error: error.message, usuarios: [] }
  return { success: true, usuarios: data || [] }
}

export async function carregarMenuWhatsApp() {
  const { data: config, error: errConfig } = await supabase
    .from('whatsapp_menu_config')
    .select('ativo, mensagem_boas_vindas, updated_at')
    .eq('id', 1)
    .maybeSingle()
  if (errConfig) return { success: false, error: errConfig.message }

  const { data: canais, error: errCanais } = await supabase
    .from('whatsapp_menu_canais')
    .select('codigo, opcao, titulo, titulo_botao, usuario_id')
    .order('opcao', { ascending: true })
  if (errCanais) return { success: false, error: errCanais.message }

  return {
    success: true,
    config: config || {
      ativo: true,
      mensagem_boas_vindas: ''
    },
    canais: canais || []
  }
}

export async function salvarMenuWhatsApp({ ativo, mensagem, canais }) {
  const { error: errConfig } = await supabase
    .from('whatsapp_menu_config')
    .upsert({
      id: 1,
      ativo: Boolean(ativo),
      mensagem_boas_vindas: String(mensagem || '').trim(),
      updated_at: new Date().toISOString()
    })
  if (errConfig) return { success: false, error: errConfig.message }

  for (const canal of canais || []) {
    const { error } = await supabase
      .from('whatsapp_menu_canais')
      .update({
        usuario_id: canal.usuario_id || null,
        updated_at: new Date().toISOString()
      })
      .eq('codigo', canal.codigo)
    if (error) return { success: false, error: error.message }
  }
  return { success: true }
}
